module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.321de678.ttf";